import React, { useContext } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';

import { Icon } from '@americanexpress/aqx-components';
import CardTitle from './CardTitle';
import Tncs from './Tncs';
import ApplyNowCta from './ApplyNowCta';
import CloseDrawer from './CloseDrawer';
import LearnMoreCta from './LearnMoreCta';
import UpgradeCta from './UpgradeCta';

import {
  makeGetQuickViewItems,
  makeGetFeaturedBenefits,
  makeGetRate,
  makeGetUpgradeCtaData
} from '../redux';

import { QuickViewContext } from './Tile';

import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';

import styles from '../__styles__/quickView.scss?modules';

const formatHeader = (quickViewItem = {}, featuredBenefitItem = {}) => {
  const { header, title, flag } = quickViewItem;
  const { text } = featuredBenefitItem;

  const flagString = flag ? `<span class=${styles.flag}>${flag}</span>` : '';
  if (header || title || text) {
    return `${header || title || text}${flagString}`;
  }

  return '';
};

const QuickViewItem = ({ quickViewItem, featuredBenefitItem, rate }) => {
  return (
    <div className={styles.quickViewItem}>
      <Icon
        directory="dls"
        imageName={
          quickViewItem.header
            ? quickViewItem.icon
            : featuredBenefitItem?.icon || quickViewItem.icon || ''
        }
        className={styles.quickViewItemIcon}
      />
      <div className={styles.textContainer}>
        <Sanitizer
          className={styles.header}
          Component="b"
          safelySetInnerHTML={formatHeader(quickViewItem, featuredBenefitItem)}
        />
        <Sanitizer
          className={styles.text}
          safelySetInnerHTML={quickViewItem.header ? rate : quickViewItem.text}
        />
      </div>
    </div>
  );
};

const QuickView = ({
  quickViewItems,
  featuredBenefits,
  rate,
  shortName,
  needUpgradeCta
}) => {
  const { isQuickViewOpen } = useContext(QuickViewContext);
  if (!isQuickViewOpen) {
    return null;
  }

  return (
    <div
      className={clsx(styles.container, { [styles.isOpen]: isQuickViewOpen })}
      aria-hidden={!isQuickViewOpen}
    >
      <div className={styles.quickViewTopBar}>
        <div className={styles.quickViewTopBarLeftItems}>
          <CardTitle shortName={shortName} isBottomRow={true} />
          <Tncs shortName={shortName} isBottomRow={true} />
        </div>
        <UpgradeCta shortName={shortName} isBottomRow={true} />
        {!needUpgradeCta && <ApplyNowCta shortName={shortName} isBottomRow={true} />}
        <CloseDrawer />
      </div>
      <div className={styles.quickViewItems}>
        {quickViewItems.map((item, i) => (
          <QuickViewItem
            quickViewItem={item}
            featuredBenefitItem={featuredBenefits?.[i]}
            rate={rate}
            key={i}
          />
        ))}
      </div>
      <LearnMoreCta shortName={shortName} isBottomRow={true} />
    </div>
  );
};

const mapStateToProps = () => {
  const getQuickViewItems = makeGetQuickViewItems();
  const getFeaturedBenefits = makeGetFeaturedBenefits();
  const getRate = makeGetRate();
  const getUpgradeCtaData = makeGetUpgradeCtaData();

  return (state, { shortName }) => ({
    quickViewItems: getQuickViewItems(state, shortName),
    featuredBenefits: getFeaturedBenefits(state, shortName),
    rate: getRate(state, shortName),
    needUpgradeCta: getUpgradeCtaData(state, shortName).needUpgradeCta
  });
};

export default connect(mapStateToProps)(QuickView);
